module.exports = __webpack_public_path__ + "static/2024-rails-survey-results-social-share-1200x630-4d3488179e499660afa5fbf8bbe3f4a6.png";